import React from "react";
import { Form, Button } from "semantic-ui-react";

const UpdateProfile = () => {
  const handleInput = ({ target: { name, value } }) => {};
  return (
    <Form>
      <h1>Update Profile</h1>
      <Form.Group unstackable widths={2}>
        <Form.Input label='First name' placeholder='First name' />
        <Form.Input label='Last name' placeholder='Last name' />
      </Form.Group>
      <Form.Group widths={2}>
        <Form.Input label='Stage Name' placeholder='Stage Name' />
        <Form.Input label='Phone' placeholder='Phone' />
      </Form.Group>
      <Form.Input label='Email' placeholder='Email' />
      <Form.Input label='Bio' placeholder='Bio' />
      <Form.Input label='Password' placeholder='Password' />
      <Form.Input label='Confirm Password' placeholder='Confirm Password' />
      <Form.Input
        label='Profile Pic'
        placeholder='Profile Pic'
        name='profile_pic'
        onChange={handleInput}
      />
      <Form.Input label='Confirm Password' placeholder='Confirm Password' />
      <Form.Input label='Confirm Password' placeholder='Confirm Password' />
      <Button type='submit'>Submit</Button>
    </Form>
  );
};

export default UpdateProfile;
